// eslint-disable-next-line unicorn/no-anonymous-default-export
export default (email = ''): boolean =>
  /^[\w+'.-]+@[\w+.-]+\.[\w+.-]{2,}$/.test(email);
